module.exports = __webpack_public_path__ + "img/cholesterol_meter_primary.f827a2b5.svg";